export default {
  // 面包屑
  mapManagement: '地图管理',
  mapDetail: '地图详情',
  backToList: '返回列表',
  back: '返回',

  // 视图切换
  view2D: '2D 视图',
  view3D: '3D 视图',

  // 空状态
  mapNotFound: '地图不存在或已被删除',
  missingMapId: '缺少地图 ID',
  missingMapData: '缺少地图数据，请从地图管理列表进入详情',

  // 提示信息
  map3DLoadSuccess: '3D点云加载完成 ({count} 个点)',
  map3DLoadFailed: '3D点云加载失败: {error}',
  pointsLoadSuccess: '点位列表获取成功',
  pointsLoadFailed: '点位列表获取失败',
  pointAddSuccess: '点位 "{name}" 添加成功',
  pointDeleteSuccess: '点位 "{name}" 删除成功',
  pointUpdateSuccess: '点位 "{name}" 位置更新成功',
  newPoint: '新点位',
  pointNumber: '点位 {n}',
  pointSaveFailed: '点位保存失败',
  pointSaveInProgress: '点位保存中，请稍后重试',

  // 禁行区相关
  forbiddenZoneAddSuccess: '已保存禁行区「{name}」',
  forbiddenZoneUpdateSuccess: '已更新禁行区「{name}」',
  forbiddenZoneDeleteSuccess: '已删除禁行区「{name}」',
  forbiddenZoneSaveFailed: '禁行区保存失败',
  forbiddenZoneSaveInProgress: '禁行区保存中，请稍后重试',
  forbiddenZoneCannotCoverPoints: '禁行区不能覆盖现有点位，请先移动或删除「{name}」',
  missingMapIdForForbiddenZone: '缺少地图 ID，无法保存禁行区',
  forbiddenZoneLoadFailed: '禁行区列表获取失败',

  // 地图上传
  mapUploadSuccess: '地图上传成功',
  mapUploadFailed: '地图上传失败',
  mapUploadInProgress: '地图上传中，请稍后重试',
  missingMapIdForUpload: '缺少地图 ID，无法上传地图',
  missingMapFile: '缺少地图文件',

  // Map3D 组件相关
  loadingPointCloud: '加载点云中...',
  resetCamera: '复位视角',
  checkPointCloudUrl: '请检查点云文件地址或网络连接后重试',
  missingPointCloudUrl: '未配置点云文件地址（yun_map_minio_path）',

  // Map2D 组件相关
  checkMapUrl: '请检查地图资源地址或跨域配置后重试',
  loadingMap: '加载地图中...',
  resetView: '复位视图',
  zoomIn: '放大',
  zoomOut: '缩小',
  uploadMap: '上传地图更新',
  downloadMap: '下载地图',
  editPoints: '编辑点位',
  exitEdit: '退出编辑',
  addPointMode: '添加点位模式',
  exitAddPointMode: '退出添加模式',
  deleteSelectedPoint: '删除选中点位',
  editAfterSave: '详细编辑后保存',
  saveDirectly: '直接保存点位',
  cancelTempPoint: '取消临时点位',
  forbiddenZoneMode: '禁行区（多边形）',
  exitForbiddenZone: '退出禁行区',
  undoLastVertex: '撤销上一顶点',
  closePolygon: '闭合多边形并添加',
  deleteSelectedZone: '删除选中禁行区',
  zoneModeTitle: '禁行区',
  editModeTitle: '编辑模式',
  addModeTitle: '添加模式',

  // 编辑模式提示
  zoneModeTip: '左键点击添加顶点；闭合需至少 3 点；Alt+拖移平移画布；Esc 清空当前折线；可拖拽顶点微调已保存区域',
  addModeTip: '点击地图放置临时点位（不可在禁行区内）；可拖拽点位和箭头调整位置/偏向角；右侧对勾直接保存，表单按钮详细编辑后保存，X 取消',
  selectedPointTip: '已选中点位：可拖拽位置或箭头调整偏向角，松手后点位旁确认更新（拖拽中按 Esc 取消）；双击/右键完整编辑，右侧红色按钮删除',
  normalModeTip: '点击点位进行选中；选中后可拖拽位置/偏向角并确认更新，或双击/右键打开完整编辑；需要删除时先选中再点右侧红色按钮',
  zoneModeTipTitle: '禁行区',
  addModeTipTitle: '添加',
  selectedPointTipTitle: '已选中',
  normalModeTipTitle: '提示',

  // 鼠标位置显示
  mousePosition: '位置',

  // 模态框
  confirmDeletePoint: '确认删除点位',
  confirmDelete: '确认删除',
  confirmAddPoint: '确认添加点位',
  add: '添加',
  editPoint: '编辑点位',
  save: '保存',
  cancel: '取消',

  // 表单标签
  pointName: '点位名称',
  xCoordinate: 'X坐标',
  yCoordinate: 'Y坐标',
  yawAngle: '偏向角',
  enterPointName: '请输入点位名称',
  enterXCoordinate: '请输入X坐标',
  enterYCoordinate: '请输入Y坐标',
  enterYawAngle: '请输入偏向角，0-6.28',

  // 提示和警告
  deletePointConfirm: '确定要删除点位「{name}」吗？',
  deletePointWarning: '此操作不可撤销，请谨慎操作。',
  pointPositionTip: '点击地图上的位置可快速填充坐标，偏向角范围：0-6.28弧度',
  editPointTip: '修改点位名称、坐标和偏向角，保存后生效',
  cannotMoveOutsideMap: '不能把点位移到地图范围外',
  cannotMoveToForbiddenZone: '不能把点位移到禁行区内',
  cannotAddOutsideMap: '不能在地图范围外添加点位',
  cannotAddInForbiddenZone: '不能在禁行区内添加点位',
  cannotSaveOutsideMap: '不能把点位保存到地图范围外',
  cannotSaveInForbiddenZone: '不能把点位保存到禁行区内',
  needAtLeast3Vertices: '至少需要 3 个顶点才能闭合',
  forbiddenZoneCannotCoverPointsShort: '禁行区不能覆盖现有点位，请先移动或删除「{name}」',

  // 地图相关
  missingMapUrl: '未配置地图地址（map_minio_path）',
  mapNameMustBe: '上传文件名称必须为 map.pgm',
  noMapUrlCannotDownload: '未配置地图地址，无法下载',
  downloadStarted: '已开始下载地图',

  // 语音导航
  voiceNoTranscript: '未识别到文字，请重新语音输入',
  voiceTranscribeFailed: '语音识别失败，请重试',
  voiceNoPointsMatched: '未识别到地图中的点位，请重新语音输入',
  voiceNoNavigationTargets: '未识别到导航点位，请先进行语音输入',
  voiceTaskCreateSuccess: '创建任务成功',
  voiceTaskCreateFailed: '创建任务失败',

  // 通用错误
  missingMapIdForPoint: '缺少地图 ID，无法保存点位',
  operationFailed: '操作失败',

  // 按钮文本
  confirm: '确认',
  undo: '撤销',

  // 提示信息
  tip: '提示',
  yawRangeTip: '点击地图上的位置可快速填充坐标，偏向角范围：0-6.28弧度',
  editTip: '修改点位名称、坐标和偏向角，保存后生效',

  // 错误和警告信息
  mapLoadError: '未配置地图地址（map_minio_path）',
  loadFailedHttp: '加载失败 HTTP {status}',
  parsePgmFailed: '无法解析 PGM 格式，请确认文件格式正确',
  mapLoadFailed: '地图加载失败',
  forbiddenZoneNumber: '禁行区 {n}',
  confirmDeletePointMessage: '确定要删除点位「{name}」吗？',
  adjustingForbiddenZoneCannotCoverPoints: '调整后的禁行区不能覆盖现有点位，请先移动或删除「{name}」',
  uploadFileNameWarning: '上传文件名称必须为 map.pgm',
  noMapUrlDownloadWarning: '未配置地图地址，无法下载',
  downloadFailedHttp: '下载失败 HTTP {status}',
  downloadMapFailed: '地图下载失败',
  downloadMapSuccess: '已开始下载地图',
  receivedPointsData: 'Map2D接收到的点位数据:',
}